import ButtonWithText from "components/buttons/ButtonWithText";
import ButtonTheme from "types/enums/ButtonTheme";
import FontClass from "types/enums/FontClass";
import { useWalletModal } from "@solana/wallet-adapter-react-ui";
import { useWallet } from "@solana/wallet-adapter-react";
import shortenAddress from "utils/solana/shortenAddress";
import { Popover } from "antd";
import TextButton from "components/buttons/TextButton";
import TextButtonTheme from "types/enums/TextButtonTheme";

function PopoverContent() {
  const { disconnect } = useWallet();

  return (
    <div style={{ width: 238 }}>
      <TextButton
        buttonThemeOrColorClass={TextButtonTheme.Navy}
        fontClass={FontClass.Header2}
        onClick={disconnect}
        textTransform="uppercase"
      >
        Disconnect wallet
      </TextButton>
    </div>
  );
}

type Props = {
  buttonTheme: ButtonTheme;
  disconnectedLabel?: string;
  fontClass: FontClass;
  width?: number;
};

export default function ConnectWalletButton({
  buttonTheme,
  disconnectedLabel = "Connect Wallet",
  fontClass,
  width,
}: Props) {
  const { setVisible } = useWalletModal();
  const { publicKey } = useWallet();

  if (publicKey == null) {
    return (
      <ButtonWithText
        buttonTheme={buttonTheme}
        fontClass={fontClass}
        onClick={() => setVisible(true)}
        textTransform="uppercase"
        style={width != null ? { width } : undefined}
        width={width != null ? "100%" : undefined}
      >
        {disconnectedLabel}
      </ButtonWithText>
    );
  }

  return (
    <Popover
      placement="bottomRight"
      content={<PopoverContent />}
      trigger="click"
    >
      <ButtonWithText
        buttonTheme={buttonTheme}
        fontClass={fontClass}
        textTransform="uppercase"
        style={width != null ? { width } : undefined}
        width={width != null ? "100%" : undefined}
      >
        {shortenAddress(publicKey.toString())}
      </ButtonWithText>
    </Popover>
  );
}
